import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
} from "@angular/common/http";
import { environment } from "../../../../../environments/environment";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  selector: "app-college-form-create",
  templateUrl: "./college-form-create.component.html",
  styleUrls: ["./college-form-create.component.scss"],
})
export class CollegeFormCreateComponent implements OnInit {
  public Form: FormGroup;
  submitted = false;
  message = null;
  class = null;
  action = null;
  isShown: boolean = false;
  ownerships = [];
  approvedbys = [];
  country = null;
  state = null;
  city =null;
  university =null;
  // keywords = [];
  // tags = [];

  constructor(
    private ActivatedRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private http: HttpClient,
    private router: Router
  ) {}

  public reg = "(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?";

  ngOnInit() {
    let role = localStorage.getItem("userRole");
    let user = localStorage.getItem("userId");

    this.action = "Submit";
    this.ActivatedRoute.params.subscribe((params) => {
      let id = params["id"];

      this.http
        .get<any>(`${environment.apiUrl}/college/${id}`, {
          headers: {
            Userinfo: JSON.stringify({
              _id: localStorage.getItem("adminSess"),
              role: localStorage.getItem("userRole"),
            }),
          },
        })
        .subscribe(
          (data) => {
            data.message == "Logged Out!"
              ? this.router.navigateByUrl("/auth/login")
              : "";
            if (data.data != "") {
              if (role != "super-admin" && data.data.userid != user) {
                this.router.navigateByUrl("/college-details/college-info-list");
              }
              this.action = "Update";

              this.http
                .get<any>(
                  `${environment.apiUrl}/state/${id}`,
                  {
                    headers: {
                      Userinfo: JSON.stringify({
                        _id: localStorage.getItem("adminSess"),
                        role: localStorage.getItem("userRole"),
                      }),
                    },
                  }
                )
                .subscribe(
                  (data) => {
                    data.message == "Logged Out!"
                      ? this.router.navigateByUrl("/auth/login")
                      : "";
                    this.Form.patchValue({
                      // contactperson: data.data.contactperson,
                      // contactno: data.data.contactno,
                      // contactemail: data.data.contactemail,
                    });
                  },
                  (err: HttpErrorResponse) => {
                    if (err.error instanceof Error) {
                      console.log("Client-side error occured.");
                    } else {
                      console.log("Server-side error occured.");
                    }
                  }
                );

              this.Form.patchValue({
                _id: data.data._id,
                collegename: data.data.collegename,
                universityurl: data.data.universityurl,
                rating: data.data.rating,
                reviews: data.data.reviews,
                brochure: data.data.brochure,
                latitude: data.data.latitude,
                longitude: data.data.longitude,
                location: data.data.location,
                status: data.data.status,
                mediaid: data.data.mediaid,
                collegelogo: data.data.collegelogo,
                collegebannerphoto: data.data.collegebannerphoto,
                // highlights          : data.data.highlights,
                // metatitle           : data.data.metatitle,
                // metadescription     : data.data.metadescription,
                // keywordsid          : data.data.keywordsid,
                // tagsid              : data.data.tagsid,
              });

              // if (data.data.scholarship == "Enable") {
              //   this.isShown = true;
              // } else {
              //   this.isShown = false;
              // }
            }
          },
          (err: HttpErrorResponse) => {
            if (err.error instanceof Error) {
              console.log("Client-side error occured.");
            } else {
              console.log("Server-side error occured.");
            }
          }
        );
        
    });

    this.Form = this.formBuilder.group({
      collegename: ["", Validators.required],
      universityurl: ["", [Validators.required, Validators.pattern(this.reg)]],
      rating: ["", [Validators.required]],
      reviews: ["", Validators.required],
      // collegeemail: ['', [Validators.required, Validators.email]],
      latitude: ["", Validators.required],
      longitude: ["", Validators.required],
      brochure: ["", Validators.required],
      location: ["", Validators.required],
      status: ["", Validators.required],
      country: ["", Validators.required],
      state: ["", Validators.required],
      city: ["", Validators.required],
      university: ["", Validators.required],
      // scholarshipamt: ['',],
      mediaid: ["", Validators.required],
      collegelogo: ["", Validators.required],
      // contactemail: ['', [Validators.required, Validators.email]],
      collegebannerphoto: ["", Validators.required],
      // highlights: ['', Validators.required],
      // metatitle: ['', Validators.required],
      // metadescription: ['', Validators.required],
      // keywordsid: ['', Validators.required],
      // tagsid: ['', Validators.required],
      _id: [""],
    });

   

    this.http
      .get<any>(`${environment.apiUrl}/country/`, {
        headers: {
          Userinfo: JSON.stringify({
            _id: localStorage.getItem("adminSess"),
            role: localStorage.getItem("userRole"),
          }),
        },
      })
      .subscribe(
        (data) => {
          console.log(data);
          console.log(data.results);
          
          data.message == "Logged Out!"
            ? this.router.navigateByUrl("/auth/login")
            : "";
          this.country = data.results;
          console.log(data.results[0].name);
          
        },
        (err: HttpErrorResponse) => {
          if (err.error instanceof Error) {
            console.log("Client-side error occured.");
          } else {
            console.log("Server-side error occured.");
          }
        }
      );
      this.http
      .get<any>(`${environment.apiUrl}/state/`, {
        headers: {
          Userinfo: JSON.stringify({
            _id: localStorage.getItem("adminSess"),
            role: localStorage.getItem("userRole"),
          }),
        },
      })
      .subscribe(
        (data) => {
          console.log(data);
          console.log(data.results);
          
          data.message == "Logged Out!"
            ? this.router.navigateByUrl("/auth/login")
            : "";
          this.state = data.results;
          // console.log(data.results[0].name);
          
        },
        (err: HttpErrorResponse) => {
          if (err.error instanceof Error) {
            console.log("Client-side error occured.");
          } else {
            console.log("Server-side error occured.");
          }
        }
      );
      this.http
      .get<any>(`${environment.apiUrl}/city/`, {
        headers: {
          Userinfo: JSON.stringify({
            _id: localStorage.getItem("adminSess"),
            role: localStorage.getItem("userRole"),
          }),
        },
      })
      .subscribe(
        (data) => {
          console.log(data);
          console.log(data.results);
          
          data.message == "Logged Out!"
            ? this.router.navigateByUrl("/auth/login")
            : "";
          this.city = data.results;
          console.log(data.results[0].name);
          
        },
        (err: HttpErrorResponse) => {
          if (err.error instanceof Error) {
            console.log("Client-side error occured.");
          } else {
            console.log("Server-side error occured.");
          }
        }
      );
      this.http
      .get<any>(`${environment.apiUrl}/university/`, {
        headers: {
          Userinfo: JSON.stringify({
            _id: localStorage.getItem("adminSess"),
            role: localStorage.getItem("userRole"),
          }),
        },
      })
      .subscribe(
        (data) => {
          console.log(data);
          console.log(data.results);
          
          data.message == "Logged Out!"
            ? this.router.navigateByUrl("/auth/login")
            : "";
          this.university = data.results;
          // console.log(data.results[0].name);
          
        },
        (err: HttpErrorResponse) => {
          if (err.error instanceof Error) {
            console.log("Client-side error occured.");
          } else {
            console.log("Server-side error occured.");
          }
        }
      );

    
  }

  // getstate(value) {
  //   this.http
  //     .get<any>(`${environment.apiUrl}/state/${value}`, {
  //       headers: {
  //         Userinfo: JSON.stringify({
  //           _id: localStorage.getItem("adminSess"),
  //           role: localStorage.getItem("userRole"),
  //         }),
  //       },
  //     })
  //     .subscribe(
  //       (data) => {
  //         data.message == "Logged Out!"
  //           ? this.router.navigateByUrl("/auth/login")
  //           : "";
  //         this.state = data.data;
  //       },
  //       (err: HttpErrorResponse) => {
  //         if (err.error instanceof Error) {
  //           console.log("Client-side error occured.");
  //         } else {
  //           console.log("Server-side error occured.");
  //         }
  //       }
  //     );
  // }

  // getcity(value) {
  //   this.http
  //     .get<any>(`${environment.apiUrl}/city/${value}`, {
  //       headers: {
  //         Userinfo: JSON.stringify({
  //           _id: localStorage.getItem("adminSess"),
  //           role: localStorage.getItem("userRole"),
  //         }),
  //       },
  //     })
  //     .subscribe(
  //       (data) => {
  //         data.message == "Logged Out!"
  //           ? this.router.navigateByUrl("/auth/login")
  //           : "";
  //         this.city = data.data;
  //       },
  //       (err: HttpErrorResponse) => {
  //         if (err.error instanceof Error) {
  //           console.log("Client-side error occured.");
  //         } else {
  //           console.log("Server-side error occured.");
  //         }
  //       }
  //     );
  // }
  // getcountry(value) {
  //   this.http
  //     .get<any>(`${environment.apiUrl}/country/${value}`, {
  //       headers: {
  //         Userinfo: JSON.stringify({
  //           _id: localStorage.getItem("adminSess"),
  //           role: localStorage.getItem("userRole"),
  //         }),
  //       },
  //     })
  //     .subscribe(
  //       (data) => {
  //         data.message == "Logged Out!"
  //           ? this.router.navigateByUrl("/auth/login")
  //           : "";
  //         this.country = data.data;
  //       },
  //       (err: HttpErrorResponse) => {
  //         if (err.error instanceof Error) {
  //           console.log("Client-side error occured.");
  //         } else {
  //           console.log("Server-side error occured.");
  //         }
  //       }
  //     );
  // }

  // getuniversity(value) {
  //   this.http
  //     .get<any>(`${environment.apiUrl}/university/${value}`, {
  //       headers: {
  //         Userinfo: JSON.stringify({
  //           _id: localStorage.getItem("adminSess"),
  //           role: localStorage.getItem("userRole"),
  //         }),
  //       },
  //     })
  //     .subscribe(
  //       (data) => {
  //         data.message == "Logged Out!"
  //           ? this.router.navigateByUrl("/auth/login")
  //           : "";
  //         this.university = data.data;
  //       },
  //       (err: HttpErrorResponse) => {
  //         if (err.error instanceof Error) {
  //           console.log("Client-side error occured.");
  //         } else {
  //           console.log("Server-side error occured.");
  //         }
  //       }
  //     );
  // }
  // // scholarshipamt(value) {
  //   if (value == "Enable") {
  //     this.isShown = true;
  //   } else {
  //     this.isShown = false;
  //   }
  // }

  get f() {
    return this.Form.controls;
  }

  onFormSubmit() {
    this.submitted = true;

    if (this.Form.invalid) {
      return;
    }

    if (this.action == "Submit") {
      let data = {
        collegename: this.Form.value.collegename,
        universityurl: this.Form.value.universityurl,
        rating: this.Form.value.rating,
        reviews: this.Form.value.reviews,
        brochure: this.Form.value.brochure,
        latitude: this.Form.value.latitude,
        longitude: this.Form.value.longitude,
        location: this.Form.value.location,
        status: this.Form.value.status,
        'country'       : this.Form.value.country,
        'state'         : this.Form.value.state,
        'city'          : this.Form.value.city,
        'university'          : this.Form.value.university,
        mediaid: this.Form.value.mediaid,
        collegelogo: this.Form.value.collegelogo,
        collegebannerphoto: this.Form.value.collegebannerphoto,
        // contactno: this.Form.value.contactno,
        // contactemail: this.Form.value.contactemail,
        // about: this.Form.value.about,
        // highlights: this.Form.value.highlights,
        // metatitle: this.Form.value.metatitle,
        // metadescription: this.Form.value.metadescription,
        // keywordsid: this.Form.value.keywordsid,
        // tagsid: this.Form.value.tagsid,
        // userid:
        //   localStorage.getItem("userRole") != "super-admin"
        //     ? localStorage.getItem("userId")
        //     : "",
      };
      console.log(data);
      
      this.http
        .post<any>(`${environment.apiUrl}/college/`, data, {
          headers: {
            Userinfo: JSON.stringify({
              _id: localStorage.getItem("adminSess"),
              role: localStorage.getItem("userRole"),
            }),
          },
        })
        .subscribe(
          
          
          (res) => {
            res.message == "Logged Out!"
              ? this.router.navigateByUrl("/auth/login")
              : "";
            if (res.status == "500") {
              this.message = res.message;
              this.class = "btn-primary rounded px-1 py-1";
              window.scrollTo(document.documentElement.clientWidth, 0);
              return 0;
            } else {
              this.message = "Successfully Added";
              this.class = "btn-success rounded px-1 py-1";
              this.router.navigateByUrl("/college-details/college-info-list");
            }
          },
          (err: HttpErrorResponse) => {
            if (err.error instanceof Error) {
              console.log("Client-side error occured.");
            } else {
              console.log("Server-side error occured.");
            }
          }
        );
    } else {
      let data = {
        collegename: this.Form.value.collegename,
        universityurl: this.Form.value.universityurl,
        rating: this.Form.value.rating,
        reviews: this.Form.value.reviews,
        brochure: this.Form.value.brochure,
        latitude: this.Form.value.latitude,
        longitude: this.Form.value.longitude,
        location: this.Form.value.location,
        status: this.Form.value.status,
        'country'       : this.Form.value.country,
        'state'         : this.Form.value.state,
        'city'          : this.Form.value.city,
        'university'          : this.Form.value.university,
        mediaid: this.Form.value.mediaid,
        collegelogo: this.Form.value.collegelogo,
        collegebannerphoto: this.Form.value.collegebannerphoto,
        // contactno: this.Form.value.contactno,
        // contactemail: this.Form.value.contactemail,
        // about: this.Form.value.about,
        // highlights: this.Form.value.highlights,
        // metatitle: this.Form.value.metatitle,
        // metadescription: this.Form.value.metadescription,
        // keywordsid: this.Form.value.keywordsid,
        // tagsid: this.Form.value.tagsid,
        // userid:
        //   localStorage.getItem("userRole") == "super-admin"
        //     ? localStorage.getItem("userId")
        //     : "",
        _id: this.Form.value._id,
      };
      this.http
        .put<any>(`${environment.apiUrl}/college/`, data, {
          headers: {
            Userinfo: JSON.stringify({
              _id: localStorage.getItem("adminSess"),
              role: localStorage.getItem("userRole"),
            }),
          },
        })
        .subscribe(
          (res) => {
            res.message == "Logged Out!"
              ? this.router.navigateByUrl("/auth/login")
              : "";
            if (res.status == "500") {
              this.message = res.message;
              this.class = "btn-primary rounded px-1 py-1";
              window.scrollTo(document.documentElement.clientWidth, 0);
              return 0;
            } else {
              this.message = "Successfully Updated";
              this.class = "btn-success rounded px-1 py-1";
              this.router.navigateByUrl("/college-details/college-info-list");
            }
          },
          (err: HttpErrorResponse) => {
            if (err.error instanceof Error) {
              console.log("Client-side error occured.");
            } else {
              console.log("Server-side error occured.");
            }
          }
        );
    }
  }
}
